import React from 'react';

export default function BillComId({ form }) {
  const { values } = form;

  let billComId = '';

  if (values) {
    const valuesKeys = Object.keys(values);
    const billComIdKey = valuesKeys.find(
      (key) => key.includes('billcom') && key.includes('id')
    );

    if (billComIdKey) {
      billComId = values[billComIdKey];
    }
  }

  return (
    <div className="flex flex-row-reverse">
      BILL ID: {billComId || 'not synced'}
    </div>
  );
}
